import React, { FC, PropsWithChildren } from 'react';
import { IPlacerAssistantApp } from '../../services/createPlacerAssistantApp';
import { IAssistantUiManager } from '../uiManager/AssistantUiManager';

export interface IPlacerAssistantContext extends Partial<IPlacerAssistantApp> {
    assistantUiManager?: IAssistantUiManager;
}

export const PlacerAssistantContext = React.createContext<IPlacerAssistantContext>({});

export const PlacerAssistantContextProvider: FC<PropsWithChildren<Required<IPlacerAssistantContext>>> = (props) => {
    const { children, ...rest } = props;

    return <PlacerAssistantContext.Provider value={rest}>{children}</PlacerAssistantContext.Provider>;
};
